import React from "react";
import SearchDialog from "components/SearchDialog";
import { ModalProvider } from "./contexts/modal";
import Router from "./Routes";

import "./styles/styles.scss";

function App() {
  return (
    <ModalProvider>
      <Router />
      <SearchDialog />
    </ModalProvider>
  );
}

export default App;
